<label *ngIf="!hideLabel">{{ label }}</label>
<div class="color-box"
     [style.background-color]="value"
     [attr.data-after-content]="value"
     *ngIf="isDisabled"></div>
<color-chrome *ngIf="!isDisabled"
              [disableAlpha]="true"
              [color]="value"
              (onChangeComplete)="onValueChange($event)"></color-chrome>
